import firebase from 'firebase/app';
import "firebase/firestore";

export const submitRequest = async (item) => {
    try {
        const requestRef = firebase.firestore().collection("requested-companies").doc(item.name);
        await requestRef.set(item)      
    } catch (error) {
        console.log('error: ', error);
    }
}

export const getCompanyRemoteData = async (companyName) => {
    try {
        const requestRef = firebase.firestore().collection("company-data").doc(companyName);
        const doc = await requestRef.get();
        if (doc.exists) {
            return doc.data();
        }
    } catch (error) {
        console.log('error fetching company details: ', error);
    }
}

export const getCompanyMetadata = async (companyName) => {
    try {
        const requestRef = firebase.firestore().collection("company-data").doc(companyName).collection('metadata').doc('company-info');
        const doc = await requestRef.get();
        if (doc.exists) {
            return doc.data();
        }
    } catch (error) {
        console.log('error fetching company details: ', error);
    }
}

export const getApprovedCompanyReviews = async (companyName) => {
    try {
        let reviews = {};
        const reviewData = await firebase.firestore().collection("company-data").doc(companyName).collection('reviews').doc("data").get();
        // Set to empty object when it doesn't exist
        reviews.data = reviewData.exists ? reviewData.data() : {};
        
        const reviewDetails = await firebase.firestore().collection("company-data").doc(companyName).collection('reviews').doc("details").collection("v1").get();
        if (reviewDetails) {
            reviews.details = reviewDetails.docs.map(item => {
                let data = item.data();
                data.id = item.id;
                return data;
            }).filter(rev => !rev.deleted)
        }
        return reviews;
    } catch (error) {
        console.log('error fetching company reviews: ', error);
    }
}

export const getCompanyReviews = async (companyName) => {
    try {
        let reviews = {};
        const reviewData = await firebase.firestore().collection("company-data").doc(companyName).collection('reviews').doc("data").get();
        // Set to empty object when it doesn't exist
        reviews.data = reviewData.exists ? reviewData.data() : {};
        
        const reviewDetails = await firebase.firestore().collection("company-data").doc(companyName).collection('reviews').doc("details").collection("v1").get();
        if (reviewDetails) {
            reviews.details = reviewDetails.docs.map(item => {
                let data = item.data();
                
                if (data.deleted) return null; 

                data.id = item.id;
                return data;
            }).filter(item => item != null)
        }
        
        return reviews;
    } catch (error) {
        console.log('error fetching company reviews: ', error);
    }
}

export const getVerifiedCompanyList = async () => {
    try {
        const snapshot = await firebase.firestore().collection("company-data").get();

        const companyList = await Promise.all(
            snapshot.docs.map(async (doc) => {
                let data = doc.data();
                return {
                    name: data.companyName,
                    verified: data.verified
                }
            })
        )
    
        return companyList.filter(item => item.verified);
    } catch (error) {
        console.log('error!: ', error);
        return [];
    }
}

export const getAllReviews = async () => {
    try {
        const coList = await getVerifiedCompanyList();
        
        let reqList = await Promise.all(
            coList.map(async company => {
                let coResponse = await getCompanyReviews(company.name);
                if (coResponse && coResponse.details && coResponse.details.length > 0) {
                    return coResponse.details;
                }
                return null;
            })
        )

        const reviewsList = reqList.filter(item => item !== null);
        return reviewsList.flat();
    } catch (error) {
        console.log('error fetching company list')
    }
}

// If the review has already been verified, we mark as deleted ; otherwise we verify and delete
export const rejectReview = async (review) => {
    console.log('reject this: ', review);

    try {
        if (!(review && review.id)) {
            throw new Error("Error verifying review: invalid review")
        }  
        
        if (review.verified) {
            const revDoc = await firebase.firestore()
            .collection("company-data")
            .doc(review.companyName)
            .collection("reviews")
            .doc("details")
            .collection("v1")
            .doc(review.id)
            .get();

            if (revDoc.exists) {
                await firebase.firestore()
                .collection("company-data")
                .doc(review.companyName)
                .collection("reviews")
                .doc("details")
                .collection("v1")
                .doc(review.id)
                .update({
                    deleted: true
                });   
            }
        }
        else {
            // Review has not been verified; lets verify and add to collection 
            const reviewSubmission = await firebase.firestore().collection("reviews").doc(review.id).get();

            if (reviewSubmission.exists) {
                await firebase.firestore()
                .collection("reviews")
                .doc(review.id)
                .update({
                    verified: true,
                    deleted: true
                })   
            }
        }        
    } catch (error) {
        console.log('error rejecting review: ', error);
    }
}

export const verifyReview = async (review) => {
    try {

        if (!(review && review.id)) {
            throw new Error("Error verifying review: invalid review")
        }

        const reviewSubmissionSnap = firebase.firestore().collection("reviews").doc(review.id)
        
        const reviewSubmissionData = await reviewSubmissionSnap.get();

        // This review exists on the Company Object
        if (!reviewSubmissionData.exists) {
            const revDoc = await firebase.firestore()
            .collection("company-data")
            .doc(review.companyName)
            .collection("reviews")
            .doc("details")
            .collection("v1")
            .doc(review.id)
            .get();

            if (revDoc.exists && revDoc.data().deleted === true) {
                return await firebase.firestore()
                .collection("company-data")
                .doc(review.companyName)
                .collection("reviews")
                .doc("details")
                .collection("v1")
                .doc(review.id)
                .update({
                    deleted: false
                }); 
            }            
        }
        
        // This is a fresh review; let's update it 
        const reviewData = reviewSubmissionData.data();
        await firebase.firestore()
        .collection("company-data")
        .doc(reviewData.companyName)
        .collection("reviews")
        .doc("details")
        .collection("v1")
        .add({
            ...reviewData,
            verified: true,
            deleted: false
        }); 

        await firebase.firestore()
        .collection("reviews")
        .doc(review.id)
        .update({
            verified: true,
            deleted: false
        })        

    } catch (error) {
        console.log('error verifying review: ', error);
    }
}

export const getAllUnreadReviews = async () => {
    try {
        const snapshotRef = firebase.firestore().collection("reviews");
        const snapshot = await snapshotRef.where("version", "==", 2).where("verified", "==", false).where("deleted", "!=", true).get();

        const reviewsData = await Promise.all(
            snapshot.docs.map(async (doc) => {
                let data = doc.data();
                data.id = doc.id;
                return data;
            })
        )

        return !reviewsData ? [] : reviewsData;
    } catch (error) {
        console.log('error getting all unread reviews: ', error)
    }
}

export const getAllVerifiedReviews = async () => {
    try {
        let reviews = await getAllReviews();
        return reviews.filter(review => {
            if (review.verified && review.deleted !== true) {
                return true;
            }
            return false;
        })
    } catch (error) {
        console.log('error getting all verified reviews: ', error)
    }    
}

export const getAllRejectedReviews = async () => {
    try {
        let reviews = await getAllReviews();
        return reviews.filter(review => {
            if (review.verified && review.deleted === true && review.hidePermanently !== true) {
                return true;
            }
            return false;
        })
    } catch (error) {
        console.log('error fetching all rejected reviews: ', error);
    }
}

export const getCompanyBenefits = async (companyName) => {
    try {
      const benefitsDoc = await firebase.firestore().collection("company-data").doc(companyName).collection("benefits").doc("data").get();
      const benefitsData = benefitsDoc.data();

      // Return null if no benefits have been added
      if (!benefitsData) return { noData: true };

      let updateToState = {}, someData = false;
      const possibleBenefits = [
          "companyName", "homeStipend", "chair", "desk", "monitor", "wifiPlan", 
          "cellPhonePlan", "headphones", "webCam", "keyboardMouse", "coworking",
          "gym", "holiday", "birthday", "food", "massage"
      ];
      possibleBenefits.forEach((key) => {
        // benefitsData has a value for this key, so it's offered
        if (benefitsData[key]) {
          updateToState[key] = {
            offered: true,
            value: benefitsData[key].median,
          };
          someData = true;
        } else {
          // benefitsData doesn't have a value for this key so it's not offered
          updateToState[key] = {
            offered: false,
            value: "",
          };
        }
      });
      return benefitsData;
    } catch (error) {
        return { error }
    }
};

